import type { Dispatch } from "redux"
import { TYPES } from "@kiwicom/frontend-common/consts/windowConsts"
import { resize } from "@kiwicom/frontend-common/services/window/actions"

type Store = {
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dispatch: Dispatch<any>
}

export function getWidth() {
  return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
}
// DO NOT USE IT IN COMPONENTS - IT IS MEANT TO BE USED ONLY IN CORE FUNCTIONS (app.js, init...)
export function getWindowType() {
  const width = getWidth()

  if (width > 1250) {
    return TYPES.DESKTOP
  }
  if (width > 768) {
    return TYPES.TABLET
  }
  return TYPES.MOBILE
}

export function initWindowBindings(store: Store) {
  const fireResizeAction = () => store.dispatch(resize(getWindowType()))

  window.addEventListener("resize", () => {
    fireResizeAction()
    setTimeout(fireResizeAction, 500) // workaround for iOS Chrome firing event before layout changes
  })
}
